module.exports = __webpack_public_path__ + "static/media/sshot.1348cc6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/QED/sshot.jpg
// module id = 172
// module chunks = 0